module.exports = __webpack_public_path__ + "img/club_ad05.1b465ce4.jpg";